<div class="apollo-main preflight-check">

  <header>
    <h2>Preflight check</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adip sed do eiusmod tempor incse.</p>
  </header>


  <div class="instructions">
  <a (click)="show = !show" class="trigger" [ngClass]="{'opened' : show == true}"><em>How does this work?</em></a>
  <ol *ngIf="show">
    <li>Lorem ipsum dolor sit amet, consectetur adip sed do eiusmod tempor incid</li>
    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incid</li>
    <li>Lorem ipsum dolor sit amet, consectetur adip sed do eiusmod tempor incid</li>
    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incid</li>
  </ol>
  </div>


  <!--  ////// -->



  <div class="box-plugin box-tools">

    <!-- /////////////// TOOLS BAR ///////////// -->
    <div class="tools" >
      <div class="dropdowns">
        <ul>
          <li>
            <label>Zoom</label>
            <select>
              <option>50%</option>
              <option selected="selected">75%</option>
              <option>80%</option>
              <option>90%</option>
              <option>100%</option>
            </select>
          </li>
          </ul>
        </div>
        <div class="links">
          <ul>
            <!--
            <li><a (click)="showColors = !showColors"  class="trigger"><em>Colors</em></a></li>
            <li><a (click)="showMeasure = !showMeasure" class="trigger"><em>Measure</em></a></li>
            <li><a (click)="showLayers = !showLayers" class="trigger"><em>Layers</em></a></li>
            -->
          </ul>
        </div>

      </div>
      <!-- /////////////  END TOOLS BAR ///////////// -->

      <!-- /////////////  Colors ///////////// -->
      <!-- <div *ngIf="showColors" class="preflight-tool preflight-colors" >
        <ul >
          <li>
              <em>Color XYZ</em>
              <figure>
                <a (click)="showtool = 'reference'">
                <strong></strong>
                  <img src='assets/carousel_01.png' />
                </a>
              </figure>
          </li>
          <li>
              <em>Color XYZ</em>
              <figure>
                <a (click)="showtool = 'reference'">
                <strong></strong>
                  <img src='assets/carousel_01.png' />
                </a>
              </figure>
          </li>
          <li>
              <em>Color XYZ</em>
              <figure>
                <a (click)="showtool = 'reference'">
                <strong></strong>
                  <img src='assets/carousel_01.png' />
                </a>
              </figure>
          </li>
          </ul>
      </div>
      -->


      <!-- /////////////  Colors ///////////// -->
      <!--<div *ngIf="showLayers" class="preflight-tool preflight-layers" >
        <ul>
          <li class="selected">
              <em>Reference</em>
              <figure>
                <a (click)="showtool = 'reference'">
                <strong></strong>
                  <img src='assets/carousel_01.png' />
                </a>
              </figure>
          </li>
          <li>
              <em>Target</em>
              <figure>
                <a (click)="showtool = 'reference'">
                <strong></strong>
                  <img src='assets/carousel_01.png' />
                </a>
              </figure>
          </li>
          </ul>
      </div>
      -->


      <!-- /////////////  Colors ///////////// -->
      <!-- <div *ngIf="showMeasure" class="preflight-tool preflight-measures" >
      <div>
      <p>Select unit for measurement tool:</p>
          <select>
            <option>mm. (milimeters)</option>
            <option>px. (pixels)</option>
            <option>pt. (points)</option>
          </select>
        </div>
      </div>



      <div class="image-comparison">
        <figure>
          <img src='assets/graphic_test.png' title='' />
        </figure>
      </div>

  </div> -->



  </div>
